<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7 8.5C7 6.29584 8.73751 4.50142 11.0052 4.08921L11.0012 4.04546L11 3C11 2.44772 11.4477 2 12 2C12.5523 2 13 2.44772 13 3V4L12.9958 4.08939C15.263 4.50194 17 6.29617 17 8.5C17 9.05228 16.5523 9.5 16 9.5C15.4872 9.5 15.0645 9.11396 15.0067 8.61662L15 8.5C15 7.15119 13.6843 6 12 6C10.3157 6 9 7.15119 9 8.5C9 9.79885 10.22 10.9145 11.8144 10.9953L12 11C14.7339 11 17 12.9828 17 15.5C17 17.7022 15.2655 19.4954 13.0008 19.9097L13 21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21L11.0002 19.9099C8.73496 19.4959 7 17.7025 7 15.5C7 14.9477 7.44772 14.5 8 14.5C8.55228 14.5 9 14.9477 9 15.5C9 16.8488 10.3157 18 12 18C13.6843 18 15 16.8488 15 15.5C15 14.2011 13.78 13.0855 12.1856 13.0047L12 13C9.26607 13 7 11.0172 7 8.5Z"
    fill="currentColor"
  />
</svg>
